import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Logo = ({ className = "h-10 w-auto" }) => (
  <span className="inline-flex items-center rounded-lg bg-white px-3 py-1.5" data-testid="brand-logo">
    <img
      src="/logo.png"
      alt="Adipurusa Infotech Private Limited"
      className={className}
    />
  </span>
);

const links = [
  { to: "/courses", label: "Courses" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/services#contact", label: "Connect" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#0c1427]/90 backdrop-blur-md border-b border-[#203154]">
      <nav
        className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between"
        aria-label="Main Navigation"
      >
        <Link to="/" className="flex items-center" data-testid="nav-logo-link">
          <Logo className="h-8 md:h-9 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-8 text-xs font-mono uppercase tracking-widest text-[#9cb4d8]">
          {links.map((l) => (
            <NavLink
              key={l.label}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="hover:text-white transition-colors"
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/services#contact"
            data-testid="nav-enquire-button"
            className="hidden md:inline-block px-5 py-2.5 rounded bg-[#38bdf8] text-[#0c1427] font-bold text-xs font-mono uppercase tracking-wider hover:bg-white transition-colors"
          >
            Enquire Now
          </Link>
          <button
            type="button"
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 rounded border border-[#203154] text-[#9cb4d8] hover:text-white transition-colors"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          className="md:hidden border-t border-[#203154] bg-[#0c1427] px-6 py-4 space-y-3 text-xs font-mono uppercase tracking-widest text-[#9cb4d8]"
          data-testid="nav-mobile-menu"
        >
          {links.map((l) => (
            <NavLink
              key={l.label}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="block hover:text-white transition-colors"
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/services#contact"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-enquire-button"
            className="inline-block px-5 py-2.5 rounded bg-[#38bdf8] text-[#0c1427] font-bold uppercase tracking-wider hover:bg-white transition-colors"
          >
            Enquire Now
          </Link>
        </div>
      )}
    </header>
  );
};

export { Logo };
